import React from "react";

const CustomOptionButton = ({ text, index, selectedIdx, onClick, fontSize }) => {
  const isLink = text.slice(0, 8) === "https://";

  const isSelected = Array.isArray(selectedIdx)
    ? selectedIdx.includes(index)
    : selectedIdx === index;

  const baseClasses =
    "flex w-full max-w-full justify-start items-center rounded-3xl transition-all duration-300 cursor-pointer font-mali font-bold";

  // ✅ Handle fontSize prop or fall back to dynamic text size based on length
  const getTextSizeStyle = () => {
    if (fontSize) {
      return { fontSize: fontSize };
    }
    return {};
  };

  const getTextSizeClasses = () => {
    if (fontSize) {
      return "";
    }
    return text.length > 19
      ? "text-sm sm:text-base md:text-lg lg:text-xl"
      : "text-base sm:text-lg md:text-xl lg:text-2xl";
  };

  const textClasses = `${getTextSizeClasses()} w-full max-w-full whitespace-normal break-words text-left leading-tight px-4 py-3 sm:px-5 sm:py-4`;

  const imageClasses =
    "w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 object-contain";

  return (
    <div className="w-full max-w-full flex justify-center">
      {isLink ? (
        <img
          alt="option"
          src={text}
          key={index}
          onClick={() => onClick(index)}
          className={`${imageClasses} ${baseClasses} ${
            isSelected
              ? "bg-blue-300 text-white"
              : "hover:bg-blue-100 bg-gray-100"
          }`}
        />
      ) : (
        <div
          key={index}
          onClick={() => onClick(index)}
          className={`${baseClasses} ${textClasses} ${
            isSelected
              ? "bg-blue-300 text-white"
              : "hover:bg-blue-100 bg-gray-100"
          }`}
          style={getTextSizeStyle()}
        >
          {text.replaceAll("_", ",")}
        </div>
      )}
    </div>
  );
};

export default CustomOptionButton;
